import { createAction } from 'Helpers';
import messageTypes from './types';

const messageActions = {
	pushToast: createAction(messageTypes.TOASTS.PUSH),
	popToast: createAction(messageTypes.TOASTS.POP),
	clearToasts: createAction(messageTypes.TOASTS.CLEAR),
	clearNonPersistantToasts: createAction(
		messageTypes.TOASTS.CLEAR_NON_PERSISTANTS
	),

	pushSuccessToast: createAction(messageTypes.TOASTS.PUSH.SUCCESS),
	pushErrorToast: createAction(messageTypes.TOASTS.PUSH.ERROR),
	pushWarningToast: createAction(messageTypes.TOASTS.PUSH.WARNING),
	pushInfoToast: createAction(messageTypes.TOASTS.PUSH.INFO),
};

export default messageActions;
